<template>
    <div class="col-12 news-item d-flex p-3">
        <a class="link-full" :href="href"></a>
        <div class="news-item-content d-flex flex-column">
            <span class="date" v-html="`${category}`" :class="category"></span>
            <p class="news-item-title" v-html="content"></p>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'NewsItem',
        props: {
            date: String,
            category: Array,
            content: String,
            href: String
        }
    }
</script>

<style lang="scss" scoped>
    .date {
        &:before {
            content: "";
            display: block;
            width: 30px;
            height: 20px;
            float: left;
        }
    }

    .date.Jp {
        &:before {
            background: url(../../assets/news/flag/japan-flag.svg) no-repeat left center;
        }
    }

    .date.En {
        &:before {
            background: url(../../assets/news/flag/english-flag.svg) no-repeat left center;
        }
    }

    .date.Taiwan {
        &:before {
            background: url(../../assets/news/flag/taiwan-flag.svg) no-repeat left center;
        }
    }

    .date.Malaysia {
        &:before {
            background: url(../../assets/news/flag/malaysia-flag.svg) no-repeat left center;
        }
    }

    .date.China {
        &:before {
            background: url(../../assets/news/flag/chinese-flag.svg) no-repeat left center;
        }
    }

    .date.Thailand {
        &:before {
            background: url(../../assets/news/flag/thailand-flag.svg) no-repeat left center;
        }
    }

    .date.Vietnam {
        &:before {
            background: url(../../assets/news/flag/vienna-flag.svg) no-repeat left center;
        }
    }

    .date.Singapore {
        &:before {
            background: url(../../assets/news/flag/singapore-flag.svg) no-repeat left center;
        }
    }


    .news-item {
        border-bottom: 1px solid #DDDDDD;
        position: relative;

        &:first-child {
            border-top: 1px solid #DDDDDD;
        }

        &:hover {
            background: #ffffff;
        }
    }
</style>
